import { messages as msg_pl, pl } from './texts/pl.js';
import { messages as msg_en, en } from './texts/en.js';
import { messages as msg_cz, cz } from './texts/cz.js';
import { messages as msg_de, de } from './texts/de.js';
import { messages as msg_tu, tu } from './texts/tu.js';
import { messages as msg_it, it } from './texts/it.js';


console.log(pl);
export const data = {
    pl: pl,
    en: en,
    cz: cz,
    de: de,
    tu: tu,
    it: it,
};

export const messages = {
    pl: msg_pl,
    en: msg_en,
    cz: msg_cz,
    de: msg_de,
    tu: msg_tu,
    it: msg_it,
};
